import React, { useEffect } from "react";
import member1 from "../assets/imgs/Team/Merwin J.jpeg";
import member2 from "../assets/imgs/Team/Yousuf.jpeg";
import member3 from "../assets/imgs/Team/Ashok V.png";
import linkedin from "../assets/imgs/icons/linked-in.png";
import instagram from "../assets/imgs/icons/instagram.png";
import github from "../assets/imgs/icons/github.png";

const Team = () => {

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-effect");

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target); // Animate only once
        }
      });
    }, { threshold: 0.2 });

    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <section className="teams" id="team">
      <div className="effect-1">
        <img src={require("../assets/imgs/BG Effects/Lines 1.png")} alt=""/>
      </div>

      <div className="title">
        <h1 id="title" className="scroll-effect">Meet Our Team</h1>
        <p id="about-content" className="scroll-effect">
          We are a dedicated team of medical innovators, engineers, and designers committed to creating intelligent, human-centered solutions that enhance comfort, mobility,
          and independence in people’s everyday lives. With the help of technology, we transform healthcare into a more accessible, efficient, and inclusive experience for all.
        </p>
      </div>

      <div className="team-gallery">
        <div className="overlay-blue"></div>

        {[member1, member2, member3].map((member, i) => {
          const names = ["Merwin J", "Mohammed Yousuf", "Ashok V"];
          const roles = ["Team Lead", "Team Lead", "Team Lead"];
          const linkedinLinks = [
            "https://www.linkedin.com/in/merwinj",
            "https://www.linkedin.com/in/mohammed-yousuf-895534317/?trk=contact-info",
            "https://www.linkedin.com/in"
          ];
          const instaLinks = [
            "https://www.instagram.com/merrily_to_win",
            "https://www.instagram.com/_.st.o.ry._",
            "https://www.instagram.com/pheno_menalk_id"
          ];
          const githubLinks = [
            "https://github.com/MerrilyToWin",
            "https://github.com/Mohammed1265",
            "https://github.com/"
          ];

          return (
            <div key={i} className="team-mate scroll-effect">
              <img src={member} alt={names[i]} />
              <h2>{names[i]}</h2>
              <p>{roles[i]}</p>
              <div className="social-icons">
                <a href={linkedinLinks[i]} target="_blank" rel="noreferrer">
                  <img src={linkedin} alt="LinkedIn" />
                </a>
                <a href={instaLinks[i]} target="_blank" rel="noreferrer">
                  <img src={instagram} alt="Instagram" />
                </a>
                <a href={githubLinks[i]} target="_blank" rel="noreferrer">
                  <img src={github} alt="GitHub" />
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Team;
